export const PHONE = "+393773153089";
export const PHONE_LABEL = "+39 377 315 3089";
export const EMAIL = "pelletitaliana@gmail.com";
export const ADDRESS = "Via Marsicanella, 84036 Sala Consilina (SA)";

export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

export const OFFER_END = new Date("2026-11-30T23:59:59+01:00");
export const OFFER_END_LABEL = "30 novembre 2026";

export const OFFERS = [
  { id: "casa25", name: "Confezione Casa", spec: "25 sacchi da 15 kg · 375 kg", price: 159, tag: "Appartamenti" },
  { id: "famiglia40", name: "Confezione Famiglia", spec: "40 sacchi da 15 kg · 600 kg", price: 249, tag: "Più venduto" },
  { id: "bancale70", name: "Bancale Completo", spec: "70 sacchi da 15 kg · 1.050 kg", price: 399, oldPrice: 449, tag: "Scorta stagionale" },
  { id: "doppio140", name: "Doppio Bancale", spec: "140 sacchi da 15 kg · 2.100 kg", price: 779, oldPrice: 869, tag: "Case grandi" },
  { id: "inverno210", name: "Scorta Inverno", spec: "3 bancali · 210 sacchi · 3.150 kg", price: 1149, oldPrice: 1290, tag: "Massimo risparmio" },
];
export const COLLAB = "in collaborazione con Mak Holz — Hobelware und Pellet";

export const whatsapp = (msg) =>
  `https://wa.me/${PHONE.replace("+", "")}?text=${encodeURIComponent(msg)}`;

export const PRICE_NOTE = "Prezzi IVA e trasporto esclusi · Consegna e spedizione in 24/48h";
export const DELIVERY = "Consegna e spedizione online in 24/48h";

export const mailto = (subject) =>
  `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}`;

export const PRODUCTS = [
  {
    id: "casa",
    n: "01",
    tag: "Per la casa",
    title: "Sacchi per la casa",
    text: "Confezioni pratiche da maneggiare e stoccare, pensate per stufe e caldaie domestiche. Pellet in vero legno di abete per un calore pulito e costante.",
    img: "/img/stove.jpg",
    spec: "25 sacchi da 15 kg · 375 kg",
    price: "da € 159",
    unit: "/ confezione",
    cartId: "casa25",
  },
  {
    id: "bancali",
    n: "02",
    tag: "Scorta stagionale",
    title: "Bancali completi",
    text: "Il bancale intero per affrontare tutto l'inverno senza pensieri. Sempre e solo vero legno di abete, sacco dopo sacco.",
    img: "/img/pallets.jpg",
    spec: "70 sacchi da 15 kg · 1.050 kg",
    price: "da € 399",
    unit: "/ bancale",
    cartId: "bancale70",
  },
  {
    id: "negozi",
    n: "03",
    tag: "Negozi & rivenditori",
    title: "Forniture per negozi",
    text: "Forniture per punti vendita, ferramenta, garden e rivenditori. Pellet in vero legno di abete con condizioni su misura.",
    img: "/img/logs.jpg",
    spec: "Più bancali · ordini ricorrenti",
    price: "Prezzo su richiesta",
  },
  {
    id: "aziende",
    n: "04",
    tag: "Su richiesta",
    title: "Quantità su misura",
    text: "Hai esigenze particolari? Raccontaci di cosa hai bisogno e prepariamo un preventivo dedicato.",
    img: "/img/fire.jpg",
    spec: "Quantità personalizzate",
    price: "Prezzo su richiesta",
  },
];

export const VALUES = [
  { k: "Legno", v: "Vero legno di abete", d: "Materia prima naturale, scelta per la sua resa e la sua pulizia in combustione." },
  { k: "Calore", v: "Fiamma viva e costante", d: "Un pellet pensato per scaldare la casa in modo uniforme, giorno dopo giorno." },
  { k: "Filiera", v: "Con Mak Holz", d: "Una collaborazione con Mak Holz — Hobelware und Pellet, specialisti del legno." },
];
